import { Radio, Typography } from 'antd';
import type { DividerSection } from '../../../contract/types';

interface Props {
  section: DividerSection;
  onChange: (s: DividerSection) => void;
}

export function DividerEditor({ section, onChange }: Props) {
  return (
    <div>
      <Typography.Text type="secondary" style={{ fontSize: 11 }}>样式</Typography.Text>
      <br />
      <Radio.Group
        size="small"
        value={section.style}
        onChange={(e) => onChange({ ...section, style: e.target.value })}
        optionType="button"
        options={[
          { label: '横线', value: 'line' },
          { label: '分页', value: 'page_break' },
          { label: '空行', value: 'blank' },
        ]}
      />
    </div>
  );
}
